module.exports = __webpack_public_path__ + "static/img/loongDance_wx.82c324b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/loongDance_wx.png
// module id = naH9
// module chunks = 26